import { detectOverflow, type Modifier } from '@popperjs/core';

interface MaxSizeData {
    width: number;
    height: number;
}

interface MaxSizeOptions {
    padding: number;
}

const maxSize: Modifier<'maxSize', MaxSizeOptions> = {
    name: 'maxSize',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['offset', 'preventOverflow', 'flip'],
    options: { padding: 0 },
    fn({ state, name, options }) {
        const overflow = detectOverflow(state, { padding: options.padding });
        const { width, height } = state.rects.popper;
        const [basePlacement] = state.placement.split('-');
        const widthProp = basePlacement === 'left' ? 'left' : 'right';
        const heightProp = basePlacement === 'top' ? 'top' : 'bottom';

        state.modifiersData[name] = {
            width: width - overflow[widthProp],
            height: height - overflow[heightProp],
        };
    },
};

const applyMaxSize: Modifier<'applyMaxSize', Record<string, never>> = {
    name: 'applyMaxSize',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['maxSize'],
    fn({ state }) {
        const { height } = state.modifiersData.maxSize as MaxSizeData;
        state.styles.popper.maxHeight = `${height}px`;
    },
};

export function createPopperMaxHeightModifiers(edgePadding: number) {
    return [{ ...maxSize, options: { padding: edgePadding } }, applyMaxSize];
}
